import React from "react";
import styles from "./TickerStatus.module.css";
import { TickerStatusMessage } from "~components/TickerStatusMessage";
import { getMarketStatusLabel } from "~utils/tickerStatus";

interface TickerStatusProps {
  marketStatus: string;
  tickerId: string;
  ultimateParentTicker?: string;
  primarySecurityTicker?: string;
  issuerEquityTicker?: string;
}

export const TickerStatus = ({
  marketStatus,
  tickerId,
  ultimateParentTicker,
  primarySecurityTicker,
  issuerEquityTicker,
}: TickerStatusProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tickerStatus}>
        <p>{getMarketStatusLabel(marketStatus)}</p>
      </div>
      <TickerStatusMessage
        marketStatus={marketStatus}
        tickerId={tickerId}
        ultimateParentTicker={ultimateParentTicker}
        primarySecurityTicker={primarySecurityTicker}
        issuerEquityTicker={issuerEquityTicker}
      />
    </div>
  );
};
